<template>
	<div
		class="kk-badge"
		:class="[
			`kk-badge--${ theme }`,
			`kk-badge--${ dotSize }`,
		]"
	>
		<span
			v-if="formattedValue !== null"
			ref="text"
			class="kk-badge__text"
			:style="{
				'margin-left': negativeMarginX,
				'margin-right': negativeMarginX,
			}"
		>
			{{ formattedValue }}
		</span>
	</div>
</template>

<script>
export const BADGE_THEME_LIST = [
	'system',
	'marketing-state',
	'marketing-date',
	'marketing-discount',
];

export const BADGE_DOT_SIZE_LIST = [
	'md',
	'lg',
	'xl',
];

export default {
	name: 'KkBadge',
	props: {
		theme: {
			type: String,
			default: BADGE_THEME_LIST[0],
		},
		dotSize: {
			type: String,
			default: BADGE_DOT_SIZE_LIST[0],
		},
		value: {
			type: [String, Number],
			default: null,
		},
	},
	data() {
		return {
			// 用來抵銷 transform scale 縮小文字時造成的左右空間
			negativeMarginX: null,
		};
	},
	computed: {
		formattedValue() {
			// empty string
			if (typeof this.value === 'string' && this.value.trim() === '') {
				return null;
			}
			// number larger than 99
			if (this.value > 99) {
				return '99+';
			}
			return this.value;
		},
	},
	watch: {
		formattedValue() {
			this.$nextTick(this.updateNegativeMarginX);
		},
	},
	mounted() {
		this.updateNegativeMarginX();
	},
	methods: {
		updateNegativeMarginX() {
			if (!this.$refs.text) {
				return;
			}
			const textWidth = this.$refs.text.clientWidth;
			const transformScale = window.getComputedStyle(this.$refs.text).getPropertyValue('--transform-scale');
			this.negativeMarginX = Math.round(textWidth * (transformScale - 1) / 2) + 'px';
		},
	},
}
</script>
